import { useQuery } from "@tanstack/react-query"
import { Button, Card, Col, ListGroup, ListGroupItem, Row } from "react-bootstrap"
import { getRequest } from "../utils/apiRequest"
import { useRecoilValue } from "recoil";
import { userState } from "../utils/atom";
import { Loader } from "./loader";
import '../styles/card-list/card-list.scss'
import { useNavigate } from "react-router-dom";
import { formatDateTimeToDDMMYY, formatDateTimeToHHMM } from "../utils/formatDateTime";
import { CalendarEvent, PeopleFill } from 'react-bootstrap-icons'
import { shortenString } from "../utils/shortenSting";

export const UpcomingCourses = () => {

    const MAX_COURSES_TO_SHOW = 4;
    const { token } = useRecoilValue(userState);
    const navigate = useNavigate();

    const upcomingCoursesQuery = useQuery({
        queryKey: ['upcomingcourses'],
        queryFn: () => getRequest('/auth/course/upcoming?page=1&amount=4', token)
    });
    const { data } = upcomingCoursesQuery;

    return (
        <Loader isActive={upcomingCoursesQuery.isFetching || upcomingCoursesQuery.isLoading}>
            {(data) &&
                <Card className="mt-3 p-0">
                    <Card.Header style={{cursor: 'pointer'}} className="p-3" onClick={() => navigate('/all-courses')}>
                        <Row className="align-items-center">
                            <Col xs={12}><h5 className="m-0">Demnächst stattfindende Kurse</h5></Col>
                        </Row>   
                    </Card.Header>
                    <Card.Body className="p-0">
                        {(data.courses && data.courses.length < 1) &&
                            <p className="m-0 p-3">In nächster Zeit finden keine weiteren Kurse statt.</p>
                        }
                        {(data.courses && data.courses.length > 0) &&
                            <ListGroup className="card-list">
                                {data.courses.map((course, index) => {
                                    if (index < MAX_COURSES_TO_SHOW) {
                                        return (
                                            <ListGroupItem 
                                                className="card-list-item"
                                                key={course.id}
                                                onClick={() => navigate(`/course/${course.id}`)}
                                            >
                                                <Row>
                                                    <Col xs={3} className="text-center d-flex align-items-center justify-content-center">
                                                        {shortenString(course.title, 10)}
                                                    </Col>
                                                    <Col xs={3} className="text-center border-start border-end d-flex align-items-center justify-content-center">
                                                        {formatDateTimeToDDMMYY(course.date)}
                                                    </Col>
                                                    <Col xs={3} className="text-center border-end d-flex align-items-center justify-content-center">
                                                        {formatDateTimeToHHMM(course.date)} Uhr
                                                    </Col>
                                                    <Col xs={3} className="text-center d-flex align-items-center justify-content-evenly">
                                                        {course.participants.length} | {course.maxParticipants} <PeopleFill />
                                                    </Col>
                                                </Row>
                                            </ListGroupItem>
                                        )
                                    }
                                })}
                                <ListGroupItem
                                    className="card-list-item"
                                    key="card-list-item-show-more"
                                    onClick={() => navigate('/all-courses')}
                                >
                                    {`Alle anzeigen (${data.total})`}
                                </ListGroupItem>
                            </ListGroup>         
                        }
                        <Col className="text-start border-top p-3">
                            <Button
                                onClick={() => navigate('/all-planned-courses')}
                            >
                                Geplante Kurse freigeben
                            </Button>
                        </Col>
                    </Card.Body>
                </Card>
            }
        </Loader>
    )
}